"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

module.exports = function (fn, args) {
  return fn.apply(undefined, _toConsumableArray(args));
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/apply.js
// module id = 2166
// module chunks = 37